"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const keyBy_1 = tslib_1.__importDefault(require("lodash/keyBy"));
const setStartedOn_1 = tslib_1.__importDefault(require("./setStartedOn"));
/**
 * Updates submissions of questionStates for which answers
 * are provided. Returns a boolean value indicating whether
 * any submission is updated or not. This function updates
 * child state in place. For immutability, use this function
 * inside immer.produce.
 */
function updateSubmissionsInQuestionStatesForAssignment(assignmentContent, childrenStates, timeStamp, actualSubmit, answers, flagged, checkAnswersAttemptCount) {
    let isAnySubmissionUpdated = false;
    const answersByQuestionId = keyBy_1.default(answers, 'questionId');
    const childrenStatesByContentId = keyBy_1.default(childrenStates, 'contentId');
    assignmentContent.children.forEach((questionContent) => {
        const questionContentId = questionContent._id;
        const questionAnswer = answersByQuestionId[questionContentId];
        if (!questionAnswer) {
            return;
        }
        const childState = childrenStatesByContentId[questionContentId];
        if (new Date(childState.updatedAt).getTime() > new Date(timeStamp).getTime()) {
            return;
        }
        const previousResponse = childState.submissions[0].response;
        const previousResponseType = childState.submissions[0].responseType;
        const previousAnswerEvaluation = childState.submissions[0].answerEvaluation;
        const previousActualSubmit = childState.actualSubmit;
        const previousFlagged = childState.flagged;
        const previousCheckAnswersAttemptCount = childState.checkAnswersAttemptCount;
        childState.submissions[0].response = questionAnswer.response;
        childState.submissions[0].responseType = questionAnswer.responseType;
        childState.submissions[0].answerEvaluation = questionAnswer.answerEvaluation;
        childState.submissions[0].submittedOn = timeStamp;
        childState.progressMeasure = childState.submissions[0].progressMeasure = questionAnswer.progressMeasure;
        childState.actualSubmit = actualSubmit;
        childState.flagged = flagged;
        childState.checkAnswersAttemptCount = checkAnswersAttemptCount;
        delete childState.submissions[0].thumbnail;
        delete childState.submissions[0].speechToText;
        delete childState.submissions[0].processStatus;
        delete childState.submissions[0].processId;
        delete childState.submissions[0].processStartTime;
        childState.rawScore = childState.submissions[0].rawScore = questionAnswer.rawScore;
        childState.submittedOn = childState.lastSubmittedOn = timeStamp;
        childState.lastAccessedOn = childState.updatedAt = timeStamp;
        setStartedOn_1.default(childState, timeStamp);
        if (previousResponse !== childState.submissions[0].response ||
            previousResponseType !== childState.submissions[0].responseType ||
            previousAnswerEvaluation !== childState.submissions[0].answerEvaluation ||
            previousActualSubmit !== childState.actualSubmit ||
            previousFlagged !== flagged ||
            previousCheckAnswersAttemptCount !== checkAnswersAttemptCount) {
            childState.updatedAt = timeStamp;
            isAnySubmissionUpdated = true;
        }
    });
    return isAnySubmissionUpdated;
}
exports.updateSubmissionsInQuestionStatesForAssignment = updateSubmissionsInQuestionStatesForAssignment;
//# sourceMappingURL=updateSubmissionsInQuestionStatesForAssignment.js.map